const BACKEND_HOST = process.env.BACKEND_HOST
const BACKEND_PORT = process.env.BACKEND_PORT
const HOST = `${BACKEND_HOST}:${BACKEND_PORT}`

export const VERIFY_EMAIL = `${HOST}/verify_email`



// WEBPACK FOOTER //
// ./app/api/verifyEmail/constants.js